const FETCH_GRAPH_EDGES = 'FETCH_GRAPH_EDGES';
export const FETCH_GRAPH_EDGES_START = `${FETCH_GRAPH_EDGES}_START`;
export const FETCH_GRAPH_EDGES_SUCCESS = `${FETCH_GRAPH_EDGES}_SUCCESS`;
export const FETCH_GRAPH_EDGES_FAIL = `${FETCH_GRAPH_EDGES}_FAIL`;

export const fetchServiceGraphEdges = () => {
  return {
    type: FETCH_GRAPH_EDGES,
    meta: {
      xmApi: true,
      method: 'getall',
      uri: '/api/xm/1/service-dependencies',
      params: {
        limit: 1000,
      },
    },
  };
};

export const FETCH_GRAPH_NODES = 'FETCH_GRAPH_NODES';
export const FETCH_GRAPH_NODES_START = `${FETCH_GRAPH_NODES}_START`;
export const FETCH_GRAPH_NODES_SUCCESS = `${FETCH_GRAPH_NODES}_SUCCESS`;
export const FETCH_GRAPH_NODES_FAIL = `${FETCH_GRAPH_NODES}_FAIL`;

export const fetchServiceGraphNodes = () => {
  return {
    type: FETCH_GRAPH_NODES,
    meta: {
      xmApi: true,
      method: 'getall',
      uri: '/api/xm/1/services',
      params: {
        embed: 'recentChange',
        include: 'metrics',
        limit: 1000,
      },
    },
  };
};

export const DELETE_EDGE_FROM_REDUX = 'GRAPH/DELETE_EDGE_FROM_REDUX';
export function deleteEdgeFromRedux(edgeId) {
  return {
    type: DELETE_EDGE_FROM_REDUX,
    payload: {
      edgeId,
    },
  };
}

export function deleteEdgeFromServer(edgeId) {
  return {
    type: 'GRAPH/DELETE_EDGE_FROM_SERVER',
    meta: {
      xmApi: true,
      method: 'del',
      uri: `/api/xm/1/service-dependencies/${edgeId}`,
    },
  };
}

const ADD_GRAPH_EDGE = 'ADD_GRAPH_EDGE';
export const ADD_GRAPH_EDGE_START = `${ADD_GRAPH_EDGE}_START`;

export function addServiceGraphEdge(edge) {
  return {
    type: ADD_GRAPH_EDGE,
    meta: {
      xmApi: true,
      method: 'post',
      uri: '/api/xm/1/service-dependencies',
      params: {
        serviceId: edge.target,
        dependentServiceId: edge.source,
        id: edge.id,
      },
    },
    payload: { edge }, // for front-end Redux manipulations only
  };
}
